import { ErrorCode } from './ErrorCode'
import { ErrorCategory } from './ErrorCategory'

export class AppError extends Error {
  public code: ErrorCode
  public category: ErrorCategory
  public retryable: boolean
  public details?: Record<string, unknown>

  constructor({
    message,
    code,
    category,
    retryable = false,
    details
  }: {
    message: string
    code: ErrorCode
    category: ErrorCategory
    retryable?: boolean
    details?: Record<string, unknown>
  }) {
    super(message)
    this.name = 'AppError'
    this.code = code
    this.category = category
    this.retryable = retryable
    this.details = details
  }
}
